import { MOBILE_VIEW_SEARCH_PARAM } from 'common/constants';
import { createSelector } from 'reselect';
import { RootState } from 'store';

export const getPathname = createSelector(
  ({ router }: RootState) => router.path,
  s => s
);
export const getSearch = createSelector(
  ({ router }: RootState) => router.search,
  s => s
);
export const getHost = ({ host = '' }) => host;
export const getBaseUrl = createSelector(
  getHost,
  getPathname,
  (host, pathname) => `https://${host}${pathname}`
);

export const getHostname = createSelector(getHost, host => host?.replace(/:[0-9]+/, ''));

export const getDomain = createSelector(getHostname, hostname => {
  let result = '';
  if (hostname) {
    const localhost = 'localhost';
    const separator = '.';
    const start = hostname.indexOf(separator);

    const isIpAddress =
      /^(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])$/g.test(
        hostname
      );

    if (isIpAddress) {
      return hostname;
    }

    if (hostname.endsWith(localhost)) {
      const splitted = hostname.split('.');

      return splitted[splitted.length - 1];
    }

    if (start !== -1) {
      const split = hostname.split(separator);

      result = hostname
        .split(separator)
        .slice(split.length - 2)
        .join(separator);
    }
  }

  return result;
});

export const getIsMobileView = createSelector(getSearch, search =>
  search?.includes(MOBILE_VIEW_SEARCH_PARAM)
);
